import { startOfWeek } from 'date-fns';
import { nlBE } from 'date-fns/locale';

export const nlBELocaleStartOfWeek = (val: Date): Date => {
    return startOfWeek(val, { locale: nlBE });
}